'use strict'

/**
 * CMYKColor
 * Workflow: lightweight value container for CMYK components.
 */
class CMYKColor {
    /**
     * @param {number|Array<number>} c C component or [c, m, y, k] array.
     * @param {number} m M component.
     * @param {number} y Y component.
     * @param {number} k K component.
     */
    constructor(c = 0.0, m = 0.0, y = 0.0, k = 0.0) {
        if (Array.isArray(c)) {
            this.c = c[0]
            this.m = c[1]
            this.y = c[2]
            this.k = c[3]
            return
        }

        this.c = c
        this.m = m
        this.y = y
        this.k = k
    }

    /**
     * Human-readable string representation.
     * @returns {string}
     */
    toString() {
        const c = Number(this.c).toFixed(2)
        const m = Number(this.m).toFixed(2)
        const y = Number(this.y).toFixed(2)
        const k = Number(this.k).toFixed(2)
        return `CMYKColor - C=${c} - M=${m} - Y=${y} - K=${k}`
    }
}

export default CMYKColor
